import { render, staticRenderFns } from "./new-transfer-tab.vue?vue&type=template&id=350b11f9&scoped=true&lang=pug&"
import script from "./new-transfer-tab.vue?vue&type=script&lang=js&"
export * from "./new-transfer-tab.vue?vue&type=script&lang=js&"
import style0 from "./new-transfer-tab.vue?vue&type=style&index=0&id=350b11f9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350b11f9",
  null
  
)

export default component.exports